
/* eslint-disable */
import axios from 'axios';
const state = {
    tournamentId: null,
    tournamentItem: null,
    playerIsParticipant: false,
    playerIsCheckedIn: false,
   
    isLoadingAction: false,
    participationCheckComplete: false,

    // LAN tournament
    LAN_tournamentId: null,
    LAN_tournamentItem: null,
    LAN_playerIsParticipant: false,
    LAN_playerIsCheckedIn: false,
   
    LAN_isLoadingAction: false,
    LAN_participationCheckComplete: false,

};

const actions = {
    getTournament({commit, dispatch}, tournamentId){
        axios.get('https://lgame.gg/api/v1/tournaments/'+tournamentId)
        .then(response => {
            commit('setTournament', response.data.data);
            dispatch('checkParticipation');
        }).catch(error => {
            console.log('error');
            console.log(error);
        });
        
    },
      checkParticipation({commit, state, rootState}){

        if(!rootState.currentUser.isAuthenticated){
           
            state.participationCheckComplete = true;
            return; // user not logged in
        }
       const playerId = rootState.currentUser.user.player.id;
      
       return axios.post('https://lgame.gg/api/v1/user/player/participant-in', {
           tournament_id: state.tournamentItem.id,
           player_id: playerId,
           participant_type: state.tournamentItem.settings.play_mode.size > 1 ? 'team' : 'player',
           game_id: state.tournamentItem.game_id
       })
           .then(response => {
               
               if(response.data.success === true){
                  
                   if(state.tournamentItem.settings.play_mode.size === 1){
                       commit('checkParticipation', response.data.isParticipant);
                       commit('checkPlayerIn', {
                           checkinValue: response.data.isCheckedIn
                       });
                   }else{
                       commit('checkTeamParticipation', response.data);
                       commit('checkTeamIn', {
                           checkinValue: response.data.isCheckedIn
                       });
                   }

               }
           })
           .catch(error => {
               console.log(error.response);
           })
    },
    checkPlayerIn({commit, state, rootState}, payload){
        const tournamentId = state.tournamentItem.id;
        const playerId = rootState.currentUser.user.player.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/checkin',{
            checkinValue: payload.checkinValue,
            participant_type: 'Player',
            player_id: playerId,
        })
            .then(response => {
                if(response.data.success){
                    commit('checkPlayerIn', {
                        participants: response.data.data,
                        checkinValue: payload.checkinValue,
                    });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    },
    /**
     *  this function is used by player to participate in tournament
     */
    setParticipant({commit, state, rootState}, payload){
        const playerId = rootState.currentUser.user.player.id;
        const tournamentId = state.tournamentItem.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/participate', {
            participant_id: playerId,
            participant_type: 'Player',
            custom_fields: payload?.customFieldsValue,
        })
            .then(response => {
                if(response.data.success){
                   
                    commit('setPlayerIsParticipant', response.data.data);
                }
            })
            .catch(error => {
                console.log('===================================== catch error message START =========================')
                console.log(error)
                console.log('===================================== catch error message END =========================')
            });
    },

    /**
     * this function is used by a player to cancel his participation
     */
    cancelParticipation({commit, state, rootState}){

        const tournamentId = state.tournamentItem.id;
        const playerId = rootState.currentUser.user.player.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/remove', {
            participant_id: playerId,
            participant_type: 'Player',
        })
            .then(response => {
                
                if(response.data.success){
                    //const currentTournament = rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId);
                    //console.log(currentTournament);
                    /*if(currentTournament){

                    }

                    rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId).participants_players = response.data.data;
                    rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId)
                        .participants_players_count -= 1;*/
                    state.tournamentItem.participants_players = response.data.data;
                    commit('cancelParticipation', response.data.data);
                }
            })
    },
    triggerLoading({commit}, isLoading){
        commit('triggerLoading', isLoading);
    },
    // LAN tournament actions

    LAN_getTournament({commit, dispatch}, tournamentId){
        axios.get('https://lgame.gg/api/v1/tournaments/'+tournamentId)
        .then(response => {
            commit('LAN_setTournament', response.data.data);
            dispatch('LAN_checkParticipation');
        }).catch(error => {
            console.log('error');
            console.log(error);
        });
        
    },
      LAN_checkParticipation({commit, state, rootState}){

        if(!rootState.currentUser.isAuthenticated){
           
            state.LAN_participationCheckComplete = true;
            return; // user not logged in
        }
       const playerId = rootState.currentUser.user.player.id;
      
       return axios.post('https://lgame.gg/api/v1/user/player/participant-in', {
           tournament_id: state.LAN_tournamentItem.id,
           player_id: playerId,
           participant_type: state.tournamentItem.settings.play_mode.size > 1 ? 'team' : 'player',
           game_id: state.tournamentItem.game_id
       })
           .then(response => {
               
               if(response.data.success === true){
                  
                   if(state.tournamentItem.settings.play_mode.size === 1){
                       commit('LAN_checkParticipation', response.data.isParticipant);
                       commit('LAN_checkPlayerIn', {
                           checkinValue: response.data.isCheckedIn
                       });
                   }else{
                       commit('LAN_checkTeamParticipation', response.data);
                       commit('LAN_checkTeamIn', {
                           checkinValue: response.data.isCheckedIn
                       });
                   }

               }
           })
           .catch(error => {
               console.log(error.response);
           })
    },
    LAN_checkPlayerIn({commit, state, rootState}, payload){
        const tournamentId = state.LAN_tournamentItem.id;
        const playerId = rootState.currentUser.user.player.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/checkin',{
            checkinValue: payload.checkinValue,
            participant_type: 'Player',
            player_id: playerId,
        })
            .then(response => {
                if(response.data.success){
                    commit('LAN_checkPlayerIn', {
                        participants: response.data.data,
                        checkinValue: payload.checkinValue,
                    });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    },
    /**
     *  this function is used by player to participate in tournament
     */
    LAN_setParticipant({commit, state, rootState}, payload){
        const playerId = rootState.currentUser.user.player.id;
        const tournamentId = state.LAN_tournamentItem.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/participate', {
            participant_id: playerId,
            participant_type: 'Player',
            custom_fields: payload?.customFieldsValue,
        })
            .then(response => {
                if(response.data.success){
                    commit('LAN_setPlayerIsParticipant', response.data.data);
                }
            })
            .catch(error => {
                console.log('===================================== catch error message START =========================')
                console.log(error)
                console.log('===================================== catch error message END =========================')
            });
    },

    /**
     * this function is used by a player to cancel his participation
     */
    LAN_cancelParticipation({commit, state, rootState}){

        const tournamentId = state.LAN_tournamentItem.id;
        const playerId = rootState.currentUser.user.player.id;
        return axios.post('https://lgame.gg/api/v1/user/tournament/'+tournamentId+'/participant/remove', {
            participant_id: playerId,
            participant_type: 'Player',
        })
            .then(response => {
                
                if(response.data.success){
                    //const currentTournament = rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId);
                    //console.log(currentTournament);
                    /*if(currentTournament){

                    }

                    rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId).participants_players = response.data.data;
                    rootState.tournament.tournamentsList.find(tournament => tournament.id === tournamentId)
                        .participants_players_count -= 1;*/
                    state.LAN_tournamentItem.participants_players = response.data.data;
                    commit('LAN_cancelParticipation', response.data.data);
                }
            })
    },
    triggerLoading({commit}, isLoading){
        commit('triggerLoading', isLoading);
    },





};

const  mutations = {
    setTournament(state, tournament){
        state.tournamentItem = tournament;
        state.tournamentItem.bracket.structure = JSON.parse(state.tournamentItem.bracket.structure);
        state.tournamentItem.bracket.settings = JSON.parse(state.tournamentItem.bracket.settings);
    },
     setPlayerIsParticipant(state, participants){
       
        state.playerIsParticipant = true;
        state.tournamentItem.participants_players = participants;
        //rootState.tournament.tournamentsList. for participants
        //rootState.tournament.tournamentsList. for count
    },
     cancelParticipation(state, participants){
        
        state.playerIsParticipant = false;
        state.playerIsCheckedIn = false;
        state.tournamentItem.participants_players = participants;
     },
    checkPlayerIn(state, payload) {
        state.playerIsCheckedIn = payload.checkinValue;
        if(payload.participants){
            state.tournamentItem.participants_players = payload.participants;
        }
    },
    checkParticipation(state, isParticipant){
        state.playerIsParticipant = isParticipant;
        state.participationCheckComplete = true;
    },
    triggerLoading(state, isLoading){
        state.isLoadingAction = isLoading;
    },

    // For LAN tournament
    LAN_setTournament(state, tournament){
        state.LAN_tournamentItem = tournament;
        state.LAN_tournamentItem.bracket.structure = JSON.parse(state.tournamentItem.bracket.structure);
        state.LAN_tournamentItem.bracket.settings = JSON.parse(state.tournamentItem.bracket.settings);
    },
     LAN_setPlayerIsParticipant(state, participants){
       
        state.LAN_playerIsParticipant = true;
        state.LAN_tournamentItem.participants_players = participants;
        //rootState.tournament.tournamentsList. for participants
        //rootState.tournament.tournamentsList. for count
    },
     LAN_cancelParticipation(state, participants){
        
        state.LAN_playerIsParticipant = false;
        state.LAN_playerIsCheckedIn = false;
        state.LAN_tournamentItem.participants_players = participants;
     },
    LAN_checkPlayerIn(state, payload) {
        state.LAN_playerIsCheckedIn = payload.checkinValue;
        if(payload.participants){
            state.LAN_tournamentItem.participants_players = payload.participants;
        }
    },
    LAN_checkParticipation(state, isParticipant){
        state.LAN_playerIsParticipant = isParticipant;
        state.LAN_participationCheckComplete = true;
    },
    LAN_triggerLoading(state, isLoading){
        state.LAN_isLoadingAction = isLoading;
    },
};




export default {
    namespaced: true,
    state,
    actions,
    mutations,
}